import type { FaireProductEntity } from "../../entity_types/product";

export const p_pmvhzwezyx: FaireProductEntity = {
  token: "p_pmvhzwezyx",
  type: "product",
  name: "Coconut + Lime 22 oz Glass Candle – Sold as a Case Of 3",
  brandToken: "b_a9sxagnm95",
  brandName: "Forget Me Not Candle",
  imageUrl:
    "https://cdn.faire.com/fastly/d1aa93285cc05ff703010ad858d8ea53324b1dfb2441c8999b64ae844f69c75b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4fd221b1c223f8101a8755c02d042a5d15607709686ca4e9550efbed04c71642.jpeg",
    "https://cdn.faire.com/fastly/63184314ad7689558e37887c325609a992d6c5998759b3cc4ca941a021b19359.jpeg",
    "https://cdn.faire.com/fastly/578d09b90f018968b104a7673f18b07505196aa2c10625a2e4dd42570f197583.jpeg",
    "https://cdn.faire.com/fastly/b62900d3f285d222c8ab537e166203335a20656da014324291366fe43fa98a06.jpeg",
  ],
  priceDollars: 19.75,
  description:
    "150 Hour Burn Time | Place a tropical paradise into your home and relax with our Coconut + Lime soy candles. Notes of lime, coconut, bergamot, pineapple, Tangerine, ozone, and grapefruit. A perfect balance of a fruit, citron, and tropical air wrapped up in pure sophistication.\n\n• Headache-Free Burn\n• 100% USA grown Soy Wax\n• 30-50% Longer Burn Time\n• 100% Phthalate-Free\n• Non-Toxic Formula poured into a Reusable Glass Jar finished with a modern-organic 100% Biodegradable cork lid",
  tags: [],
  msrpDollars: 40.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:58.556Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
